import { ISettingsService } from '@/features/shared/ISettingsService';
import { Settings } from '@/features/shared/models/Settings';
import { injectable, inject } from 'inversify-props';
import { ISettingsApi, ISettingsApiId } from '@/features/shared/ISettingsApi';

@injectable()
export default class SettingsService implements ISettingsService {
    @inject(ISettingsApiId)
    api!: ISettingsApi;

    async getSettings(): Promise<Settings> {
        try {
            return await this.api.getSettings();
        } catch {
            return { isReadOnly: true, showMpcStatistics: false } as Settings;
        }
    }
}
